import { ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useTenant } from "../../context/TenantContext";
import "./ActingAsBanner.scss";

/**
 * Viditelny pruh, ked SUPERADMIN "pracuje ako" prevadzka (token s actingAs).
 * Bez neho by bolo prilis lahke omylom zmenit ostre data zakaznika v domneni,
 * ze je clovek v testovacej firme. Token ma aj tak platnost len 1 h.
 *
 * "Ukoncit" zahodi token TEJTO prevadzky a vrati sa do /sprava -- platformovy
 * token tam ostal vo vlastnom kluci (tenantStorage), takze netreba sa
 * prihlasovat znova.
 */
function ActingAsBanner() {
  const { actingAs, logout } = useAuth();
  const { branding } = useTenant();

  if (!actingAs) return null;

  const ukoncit = () => {
    logout();
    window.location.assign("/sprava");
  };

  return (
    <div className="acting-as-banner" role="status">
      <ShieldAlert size={18} aria-hidden="true" />
      <span className="acting-as-banner__text">
        Pracuješ ako <strong>správca systému</strong> vo firme <strong>{branding.displayName}</strong>
      </span>
      <button type="button" className="acting-as-banner__btn" onClick={ukoncit}>
        <LogOut size={14} aria-hidden="true" /> Ukončiť
      </button>
    </div>
  );
}

export default ActingAsBanner;
